import { Deserialize, Deserializable } from "../helpers/serialization";
import { Color32 } from "./color";

export class TextProperties extends Deserializable
{
    @Deserialize()
    color:Color32 = new Color32();

    @Deserialize()
    size:string = "12px";

    @Deserialize()
    weight:string = "normal";

    @Deserialize()
    font:string = "sans-serif";

    @Deserialize()
    verticalOffset:number = 0;

    @Deserialize()
    horizontalOffset:number = 0;

    css():string
    {
        return `${this.weight} ${this.size} ${this.font}`;
    }
}